import Inflector from 'utils/platform/inflector.js'
import FormattedNumber from 'utils/platform/formatted_number.js'

export default class UnitsFormatter
  @displayUnits: (value, format, units) ->
    if format == "percent"
      "of #{units}"
    else if value == "1" || value == 1
      inflector = new Inflector()
      inflector.singularize(units)
    else
      units

  @hideUnits: (units) ->
    units in ["percent", "dollars", "minutes"]

  @formatChange: (change) ->
    if !change?
      {percent: "–", direction: "positive"}
    else
      formattedChange = new FormattedNumber(change)
      formattedChange.asPercent(1)
      formattedChange.number = Math.abs(formattedChange.number)

      if change == 0
        formattedChange = "0.0%"
        changeDirection = "neutral"
      else if change > 0
        formattedChange = formattedChange.toString()
        changeDirection = "positive"
      else if change < 0
        formattedChange = formattedChange.toString()
        changeDirection = "negative"
      {percent: formattedChange, direction: changeDirection}



// WEBPACK FOOTER //
// ./app/javascript/utils/platform/units_formatter.js.coffee